import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Box from '../../../../components/Box';
import CustomNumberInput from '../../../../components/CustomNumberInput';
import CustomSingleSelect, { CustomSingleSelectModel } from '../../../../components/CustomSingleSelect';
import { Helpers } from '../../../../helpers/Helpers';
import { GetAgreementByIdResponseAgreementDetail } from '../../../../models/response/agreement/GetAgreementByIdResponse';
import { GetServiceByIdResponse, GetServiceByIdResponseServiceMultiplier } from '../../../../models/response/service/GetServiceByIdResponse';
import { storeActivityIndicator, storeAreYouSureModalCallback } from '../../../../redux/reducers/authSlice';
import { ConstantService } from '../../../../services/ConstantService';
import { ServiceService } from '../../../../services/ServiceService';
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import toast from "react-hot-toast";

interface Props {
    agreementDetailsRef: any
    agreementDetails: GetAgreementByIdResponseAgreementDetail[]
    isIncome: boolean
    setAgreementDetails: React.Dispatch<React.SetStateAction<GetAgreementByIdResponseAgreementDetail[]>>
}

const AgreementDetails = ({
    agreementDetailsRef,
    agreementDetails,
    isIncome,
    setAgreementDetails
}: Props) => {
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const [selectedService, setSelectedService] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedMultiplier1, setSelectedMultiplier1] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedMultiplier2, setSelectedMultiplier2] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedCurrencyType, setSelectedCurrencyType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [unitPrice, setUnitPrice] = useState<string | undefined>('0');
    const [minPrice, setMinPrice] = useState<string | undefined>('0');
    const [multiplierList, setMultiplierList] = useState<GetServiceByIdResponseServiceMultiplier[]>([]);
    const [selectedPotType, setSelectedPotType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [agreementDetailId, setAgreementDetailId] = useState('');

    const onServiceSelected = async (selectedService: CustomSingleSelectModel | undefined) => {
        if (!selectedService) {
            setSelectedService(undefined);
            setMultiplierList([]);
            return;
        }

        try {
            dispatch(storeActivityIndicator(true));

            var response: GetServiceByIdResponse = await ServiceService.getServiceById(selectedService.value);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setSelectedService(selectedService);
            setMultiplierList(response.data.serviceMultipliers);
        } catch (error: any) {
            toast.error(error);
        }
        finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    const cancelAdding = () => {
        if (!isOpen) {
            setIsOpen(true);
            scrollTo();
            return;
        }

        setAgreementDetailId('');
        onServiceSelected(undefined);
        setMultiplierList([]);
        setSelectedMultiplier1(undefined);
        setSelectedPotType(undefined);
        setSelectedMultiplier2(undefined);
        setUnitPrice('0');
        setMinPrice('0');
        setSelectedCurrencyType(undefined);
        setIsOpen(false);
        scrollTo();
    }

    const setUpdateItem = () => {
        var o = agreementDetails.filter(x => x.isSelected)[0];

        setAgreementDetailId(o.agreementDetailId);
        onServiceSelected(o.serviceId ? { label: o.serviceName + '', value: o.serviceId } : undefined);
        setSelectedMultiplier1(o.multiplier1Id ? { label: o.multiplier1Name + '', value: o.multiplier1Id } : undefined);
        setSelectedPotType(o.potTypeId ? { label: o.potTypeName + '', value: o.potTypeId } : undefined);
        setSelectedMultiplier2(o.multiplier2Id ? { label: o.multiplier2Name + '', value: o.multiplier2Id } : undefined);
        setSelectedCurrencyType(o.currencyTypeId ? { label: o.currencyTypeName + '', value: o.currencyTypeId } : undefined);
        setUnitPrice(o.unitPrice);
        setMinPrice(o.minPrice);
        setIsOpen(true);
        scrollTo();
    }

    const deleteItems = () => {
        setAgreementDetails(agreementDetails.filter(x => !x.isSelected));
    }

    const scrollTo = () => {
        var headerOffset = 120;
        var elementPosition = agreementDetailsRef.current.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    const saveItem = () => {
        if (!selectedService) {
            toast.error('Hizmet Kalemi alanını doldurunuz!')
        }
        else if (!selectedMultiplier1) {
            toast.error('Çarpan 1 alanını doldurunuz!')
        }
        else if (Helpers.isEmpty(unitPrice)) {
            toast.error('Birim Fiyat alanını doldurunuz!')
        }
        else if (Helpers.isEmpty(minPrice)) {
            toast.error('Min. Fiyat alanını doldurunuz!')
        }
        else if (!selectedCurrencyType) {
            toast.error('Döviz Cinsi alanını doldurunuz!')
        }
        else {
            if (Helpers.isEmpty(agreementDetailId)) {
                var o: GetAgreementByIdResponseAgreementDetail = {
                    agreementDetailId: Helpers.generateUUID(true),
                    isSelected: false,
                    currencyTypeId: selectedCurrencyType?.value,
                    currencyTypeName: selectedCurrencyType?.label,
                    multiplier1Id: selectedMultiplier1?.value,
                    multiplier1Name: selectedMultiplier1?.label,
                    potTypeId: selectedPotType?.value,
                    potTypeName: selectedPotType?.label,
                    multiplier2Id: selectedMultiplier2?.value,
                    multiplier2Name: selectedMultiplier2?.label,
                    serviceId: selectedService?.value,
                    serviceName: selectedService?.label,
                    unitPrice: Helpers.toNumber(unitPrice).toFixed(2),
                    minPrice: Helpers.toNumber(minPrice).toFixed(2),
                    multiplier1Key: selectedMultiplier1?.additionalValue1,
                    multiplier2Key: selectedMultiplier2?.additionalValue1
                }

                setAgreementDetails([...agreementDetails, o])
            }
            else {
                setAgreementDetails(agreementDetails.map(function (x) {
                    if (x.agreementDetailId == agreementDetailId) {
                        x.isSelected = false;
                        x.currencyTypeId = selectedCurrencyType?.value;
                        x.currencyTypeName = selectedCurrencyType?.label;
                        x.multiplier1Id = selectedMultiplier1?.value;
                        x.multiplier1Name = selectedMultiplier1?.label;
                        x.potTypeId = selectedPotType?.value;
                        x.potTypeName = selectedPotType?.label;
                        x.multiplier2Id = selectedMultiplier2?.value;
                        x.multiplier2Name = selectedMultiplier2?.label;
                        x.serviceId = selectedService?.value;
                        x.serviceName = selectedService?.label;
                        x.unitPrice = Helpers.toNumber(unitPrice).toFixed(2);
                        x.minPrice = Helpers.toNumber(minPrice).toFixed(2);
                        x.multiplier1Key = selectedMultiplier1?.additionalValue1;
                        x.multiplier2Key = selectedMultiplier2?.additionalValue1;
                    }

                    return x;
                }))
            }

            setAgreementDetailId('');
            onServiceSelected(undefined);
            setMultiplierList([]);
            setSelectedMultiplier1(undefined);
            setSelectedPotType(undefined);
            setSelectedMultiplier2(undefined);
            setUnitPrice('0');
            setMinPrice('0');
            setSelectedCurrencyType(undefined);
            setIsOpen(false);
            scrollTo();
        }
    }

    const setItemSelected = (_id: string) => {
        setAgreementDetails(agreementDetails.map(function (x) {
            if (x.agreementDetailId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    const selectAll = () => {
        var isAllSelected = agreementDetails.length == agreementDetails.filter(x => x.isSelected).length;

        setAgreementDetails(agreementDetails.map(function (x) {
            x.isSelected = !isAllSelected;
            return x;
        }))
    }

    return (
        <div className='containerPart' ref={agreementDetailsRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Anlaşma Detayları</h4>

                    {
                        isOpen && (
                            <React.Fragment>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Hizmet Kalemi</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedService}
                                                onChange={onServiceSelected}
                                                onMenuOpen={() => ServiceService.getServiceList(isIncome)}
                                                labelName='name'
                                                valueName='serviceId'
                                                additionalValue1Name={isIncome ? 'incomePercentageName' : 'outcomePercentageName'}
                                            />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput2" className="form-label">Çarpan 2</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedMultiplier2}
                                                onChange={setSelectedMultiplier2}
                                                onMenuOpen={async () => {
                                                    return {
                                                        isSuccess: true,
                                                        data: multiplierList
                                                    }
                                                }}
                                                labelName='label'
                                                valueName='value'
                                            />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Döviz Cinsi</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedCurrencyType}
                                                onChange={setSelectedCurrencyType}
                                                onMenuOpen={() => ConstantService.getConstantList('CURRENCY', undefined, undefined)}
                                                labelName='additionalValue1'
                                                valueName='constantId'
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Kap Cinsi</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedPotType}
                                                onChange={setSelectedPotType}
                                                onMenuOpen={() => ConstantService.getConstantList('POT_TYPE', undefined, undefined)}
                                                labelName='value'
                                                valueName='constantId'
                                            />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Birim Fiyat</label>
                                            <CustomNumberInput value={unitPrice} setValue={setUnitPrice} />
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Çarpan 1</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedMultiplier1}
                                                onChange={setSelectedMultiplier1}
                                                onMenuOpen={async () => {
                                                    return {
                                                        isSuccess: true,
                                                        data: multiplierList
                                                    }
                                                }}
                                                labelName='label'
                                                valueName='value'
                                            />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Min. Fiyat</label>
                                            <CustomNumberInput value={minPrice} setValue={setMinPrice} />
                                        </div>
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <Box alignItems="flex-end">
                                            <Box flexDirection="row">
                                                <Box onClick={() => saveItem()} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                    <Box mr="5px" justifyContent="center">
                                                        <i className="text-white fa fa-check" />
                                                    </Box>
                                                    <Box justifyContent="center">
                                                        <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                            </React.Fragment>
                        )
                    }

                    <Box className={isOpen ? "mt-5" : ""} flexDirection="row">
                        <Box onClick={cancelAdding} className={"actionIcon p-2 " + (!isOpen ? "bg-success" : "")} opacity={"1"} bg={isOpen ? 'orange' : undefined} justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className={"text-white fa " + (!isOpen ? 'fa-plus' : 'fa-times')} />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">{!isOpen ? 'Ekle' : 'İptal Et'}</span>
                            </Box>
                        </Box>

                        <Box onClick={agreementDetails.filter(x => x.isSelected).length == 1 ? setUpdateItem : undefined} opacity={agreementDetails.filter(x => x.isSelected).length == 1 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-edit" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Güncelle</span>
                            </Box>
                        </Box>

                        <Box onClick={agreementDetails.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={agreementDetails.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-trash" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                            </Box>
                        </Box>
                    </Box>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                <div className='d-flex'>
                                                    <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                        <input onChange={selectAll} className='form-check-input' type='checkbox' checked={agreementDetails.filter(x => x.isSelected).length > 0 && agreementDetails.filter(x => x.isSelected).length == agreementDetails.length} />
                                                    </label>
                                                </div>
                                            </th>
                                            <th>Hizmet Kalemi</th>
                                            <th>Kap Cinsi</th>
                                            <th>Çarpan 1</th>
                                            <th>Çarpan 2</th>
                                            <th>Birim Fiyat</th>
                                            <th>Min. Fiyat</th>
                                            <th>Döviz Cinsi</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            agreementDetails.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            agreementDetails.map((item, index) =>
                                                <tr>
                                                    <td style={{ width: 1 }}>
                                                        <div className='d-flex'>
                                                            <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                                <input onChange={() => setItemSelected(item.agreementDetailId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>{item.serviceName}</td>
                                                    <td>{item.potTypeName}</td>
                                                    <td>{item.multiplier1Name}</td>
                                                    <td>{item.multiplier2Name}</td>
                                                    <td className='custom-text-right'>{Helpers.correctPrice(item.unitPrice)}</td>
                                                    <td className='custom-text-right'>{Helpers.correctPrice(item.minPrice)}</td>
                                                    <td>{item.currencyTypeName}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default AgreementDetails;